import { render, staticRenderFns } from "./Vipdialog.vue?vue&type=template&id=459710bc&scoped=true&"
import script from "./Vipdialog.vue?vue&type=script&lang=js&"
export * from "./Vipdialog.vue?vue&type=script&lang=js&"
import style0 from "./Vipdialog.vue?vue&type=style&index=0&id=459710bc&scoped=true&lang=css&"
import style1 from "./Vipdialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459710bc",
  null
  
)

export default component.exports